import { useQuery } from "@apollo/client";
import { changeAntdTheme } from "mini-dynamic-antd-theme";
import { USER_SETTINGS_QUERY } from "../../graphql/query/user-settings-query";
import { GetUserSettings } from "../../graphql/__generated_types__/GetUserSettings";
import { PRIMARY_COLOUR } from "../../types";
import { useAuth } from "../use-auth";

export const useUserSettings = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    changeAntdTheme(PRIMARY_COLOUR);
  }

  const { data, loading } = useQuery<GetUserSettings>(USER_SETTINGS_QUERY, {
    skip: !isAuthenticated,
    onCompleted: (data) => {
      const { darkTheme, customPaletteHex } = data.getUserSettings;
      if (!darkTheme) {
        changeAntdTheme(customPaletteHex || PRIMARY_COLOUR);
      }
    },
  });

  const darkMode = data?.getUserSettings.darkTheme || false;
  return {
    data,
    darkMode,
    loading,
  };
};
